import React, { useEffect, useState } from 'react';

type Dimensions = {
	width: number;
	height: number;
};

export const useContainerDimensions = (ref: React.MutableRefObject<any>): Dimensions => {
	const [componentHasBeenLoaded, setComponentHasBeenLoaded] = useState(false);
	const getDimensions = () => ({
		width: ref.current.offsetWidth,
		height: ref.current.offsetHeight,
	});

	const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

	const handleResize = () => {
		setDimensions(getDimensions());
	};

	useEffect(() => {
		if (ref.current) {
			setDimensions(getDimensions());
		}

		window.addEventListener('resize', handleResize);

		setComponentHasBeenLoaded(true);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref]);

	useEffect(() => {
		if (componentHasBeenLoaded && dimensions.width === 0 && dimensions.height === 0) {
			handleResize();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [componentHasBeenLoaded]);

	return dimensions;
};
